import { PropsWithChildren } from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';

import { tokens } from '@fhs/ui';

import { AuthHeader } from '../auth-header';

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    backgroundColor: tokens.colors.$white,
    alignItems: 'flex-start',
    width: 440,
    borderColor: tokens.colors.$black10,
    borderRadius: 12,
    borderWidth: 1,
    padding: 32,
    position: 'absolute',
  },
  content: {
    flex: 1,
    paddingVertical: 16,
    width: '85%',
  },
  floatingHeader: { position: 'absolute', top: 0, left: 0, width: '100%' },
  header: { flex: 1, justifyContent: 'center', alignItems: 'center' },

  logo: { alignSelf: 'center', marginVertical: -40 },
});

export function AuthContainerDesktop({ children }: PropsWithChildren) {
  const { height } = useWindowDimensions();
  return (
    <View style={styles.header}>
      <View style={styles.floatingHeader}>
        <AuthHeader backgroundHeight={height / 2.25} imageHeight={height / 2.25} />
      </View>
      <View style={styles.container}>{children}</View>
    </View>
  );
}
